import React from 'react'
import { cn } from 'ethcss'
import helpers from 'core/helpers'
import filesHelpers from 'core/helpers/_files'
import { TEXT_DISPLAY_AS } from 'core/models/Files'
import styles from './preview__text.jcss'

type Item = {
    name: string
    displayAs: string
    thumbnail: string
    style: { [key: string]: any }
    id: number
    src: string
    fileType: string
    folderId: number
    data: string
    isDirectory: number
    type: string
    textOrientation: 'vertical' | 'horizontal'
}

const PreviewText = (p_: { item: Item }) => {
    const { item } = p_
    const isVertical = item.textOrientation === 'vertical'
    const textContent = helpers.strip_html_tags(item.name) || ''

    const getTextContentStyles = () => {
        const convertedStyles: { [key: string]: any } = {
            fontFamily: item.style.fontFamily ? item.style.fontFamily : 'inherit',
            fontSize: item.style.size.includes('px') ? item.style.size : item.style.size + 'px',
            position: 'relative',
            textDecoration: item.style.underline ? 'underline' : 'none',
            textOrientation: isVertical && 'upright',
            writingMode: isVertical && 'vertical-lr',
        }

        return convertedStyles
    }

    const mergedStyles = { ...filesHelpers.convertStyles(item.style), ...getTextContentStyles() }

    if (item.displayAs === TEXT_DISPLAY_AS.QR_CODE) {
        return (
            <div
                className={styles.previewQrCode}
                style={{
                    backgroundImage: `url(${item.thumbnail})`,
                }}
            />
        )
    }

    return (
        <div className={styles.wrapper}>
            <div className={cn(styles.plate, isVertical && styles.plateVertical)}>
                <div className={styles.content} style={mergedStyles}>
                    {textContent}
                </div>
            </div>
        </div>
    )
}

export default PreviewText
